import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardContent, Divider, Container, Button, Grid, TextField, InputAdornment, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, IconButton, Box, Dialog, DialogTitle, DialogContent, FormControl, FormLabel, Radio, RadioGroup, FormControlLabel, Snackbar } from '@mui/material';
import Page from 'src/components/Page';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'src/utils/axios';
import { useNavigate, useLocation } from 'react-router';
import Skeleton from '@mui/material/Skeleton';
import Alert from 'src/components/Alert';

function IndividualProductInquiry() {
    const navigate = useNavigate();
    const location = useLocation();

    const [modelCodeInput, setModelCodeInput] = React.useState('');
    const [serialNumberInput, setSerialNumberInput] = React.useState('');
    const [yearInput, setYearInput] = React.useState('');
    const [monthInput, setMonthInput] = React.useState('');

    const [productSearchPopUp, setProductSearchPopUp] = React.useState(false);
    const [searchType, setSearchType] = React.useState(1);
    const [searchTerm, setSearchTerm] = React.useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const [loading, setLoading] = React.useState(false);
    const [uyari, setUyari] = useState(false);
    const [uyariTip, setUyariTip] = React.useState('default');
    const [responseMessage, setresponseMessage] = useState({
        ErrorCode: '0',
        ErrorDescription: 'success_message'
    });

    useEffect(() => {
        // Check if coming from a specific page
        const previousPath = localStorage.getItem('previousPath');
        if (previousPath === '/IndividualInquiryReceipts') {
            setModelCodeInput(localStorage.getItem('modelCodeInput') || '');
            setSerialNumberInput(localStorage.getItem('serialNumberInput') || '');
            setYearInput(localStorage.getItem('yearInput') || '');
            setMonthInput(localStorage.getItem('monthInput') || '');
            setSearchType(Number(localStorage.getItem('searchType')) || 1);
            setSelectedProduct(localStorage.getItem('selectedProduct') || null);
        } else {
            clearAllInputs();
        }
    }, []);

    useEffect(() => {
        localStorage.setItem('modelCodeInput', modelCodeInput);
        localStorage.setItem('serialNumberInput', serialNumberInput);
        localStorage.setItem('yearInput', yearInput);
        localStorage.setItem('monthInput', monthInput);
        localStorage.setItem('searchType', searchType);
        localStorage.setItem('selectedProduct', selectedProduct);

        // Save the current page path to local storage for future reference
        localStorage.setItem('previousPath', location.pathname);
    }, [modelCodeInput, serialNumberInput, yearInput, monthInput, searchType, selectedProduct]);

    const handleSearch = () => {
        if (searchTerm.length <= 0) {
            setresponseMessage('Lütfen kutucukları boş bırakmayınız!...');
            setUyariTip('error');
            setUyari(true);
            return;
        }
        const data = {
            SearchType: searchType,
            SearchTerm: searchTerm
        }
        setLoading(true);
        axios.get(`GetModelCodesOfProducts/${data.SearchType}/${data.SearchTerm}`)
            .then((response) => {
                var data = response.data;
                setSearchResults(Array.isArray(data) ? data : []);
                setPage(0);
                setLoading(false);
            }).catch((error) => {
                setLoading(false);
            });
    };

    const handleSelectProduct = (product) => {
        setModelCodeInput(product.KUL_MODEL_KODU + ' - ' + product.ACIKLAMA);
        setSelectedProduct(product.MODEL_KODU);
        setProductSearchPopUp(false);
        setSearchResults([]);
        setSearchTerm('');
    };

    const sendInformationsOfProduct = () => {
        let ModelCode = selectedProduct;
        let SerialNo = Number(serialNumberInput);
        let UYear = yearInput ? Number(yearInput) : -1;
        let UPeriod = monthInput ? Number(monthInput) : -1;

        if (!ModelCode && !SerialNo) {
            setresponseMessage('Lütfen Model Kodu veya Seri No alanlarını boş bırakmayınız!...');
            setUyariTip('error');
            setUyari(true);
            return;
        }

        navigate(`/IndividualInquiryReceipts/${UYear}/${UPeriod}/${ModelCode}/${SerialNo}`);
    }

    const clearAllInputs = () => {
        setSelectedProduct(null);
        setModelCodeInput('');
        setSerialNumberInput('');
        setYearInput('');
        setMonthInput('');
    }

    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <>
            <Snackbar
                open={uyari}
                autoHideDuration={5000}
                onClose={uyariKapat}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    onClose={uyariKapat}
                    variant={uyariTip}
                    message={responseMessage}
                ></Alert>
            </Snackbar>
            <Page title={'Tekil Ürün Sorgulama'}>
                <Container maxWidth="md">
                    <Card>
                        <CardHeader
                            title="Tekil Ürüne Göre Sorgulama"
                            subheader="(*) işaretli alanlar zorunludur."
                        />
                        <Divider />
                        <CardContent>
                            <Grid container spacing={2}>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <TextField
                                        label="Model Kodu"
                                        required
                                        size="medium"
                                        value={modelCodeInput || ''}
                                        disabled
                                        fullWidth
                                        variant="outlined"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton onClick={() => { setProductSearchPopUp(true); }}>
                                                        <SearchIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <TextField
                                        label='Seri No'
                                        required
                                        variant='outlined'
                                        value={serialNumberInput}
                                        onChange={(event) => { setSerialNumberInput(event.target.value); }}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <TextField
                                        label='Yıl'
                                        variant='outlined'
                                        value={yearInput}
                                        onChange={(event) => { setYearInput(event.target.value); }}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <TextField
                                        label='Ay'
                                        variant='outlined'
                                        value={monthInput}
                                        onChange={(event) => { setMonthInput(event.target.value); }}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
                                        <Button
                                            variant="outlined"
                                            color="secondary"
                                            onClick={() => { clearAllInputs(); }}
                                        >
                                            TEMİZLE
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => { sendInformationsOfProduct(); }}
                                        >
                                            GÖNDER
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Container>
            </Page>
            <Dialog
                open={productSearchPopUp}
                onClose={() => { setProductSearchPopUp(false); setSearchResults([]); setSearchTerm(''); }}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    Ürün Listesi
                    <IconButton
                        aria-label="close"
                        size="small"
                        onClick={() => { setProductSearchPopUp(false); setSearchResults([]); setSearchTerm(''); }}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid size={12}>
                            <FormControl>
                                <FormLabel>Arama Türü</FormLabel>
                                <RadioGroup
                                    row
                                    aria-label="searchType"
                                    name="searchType"
                                    value={searchType}
                                    onChange={(e) => setSearchType(Number(e.target.value))}
                                >
                                    <FormControlLabel value={1} control={<Radio />} label="Model Koduna göre arama" />
                                    <FormControlLabel value={2} control={<Radio />} label="Açıklamaya göre arama" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid size={12}>
                            <TextField
                                label="Model Arama"
                                fullWidth
                                size='medium'
                                variant='outlined'
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </Grid>
                        <Grid size={12}>
                            <Button
                                color='secondary'
                                variant="contained"
                                fullWidth
                                onClick={() => { handleSearch(); }}
                            >
                                Arama Yap
                            </Button>
                        </Grid>
                        <Grid size={12}>
                            <TableContainer>
                                <Table size='medium'>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align='center' sx={{ fontWeight: 700 }}>Model Kodu</TableCell>
                                            <TableCell sx={{ fontWeight: 700 }}>Açıklama</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {loading ? (
                                            Array.from(new Array(4)).map((_, index) => (
                                                <TableRow key={index}>
                                                    {Array.from(new Array(2)).map((_, cellIndex) => (
                                                        <TableCell key={cellIndex} colSpan={1}>
                                                            <Skeleton animation="pulse" variant="text" width={300} />
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            ))
                                        ) : (
                                            searchResults.length > 0 && searchResults.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((result, index) => (
                                                <TableRow key={index} hover onClick={() => handleSelectProduct(result)} style={{ cursor: 'pointer' }}>
                                                    <TableCell align='center'>{result.KUL_MODEL_KODU}</TableCell>
                                                    <TableCell>{result.ACIKLAMA}</TableCell>
                                                </TableRow>
                                            ))
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                rowsPerPageOptions={[10, 25, 50]}
                                component="div"
                                count={searchResults.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </>
    );
}

export default IndividualProductInquiry;
